module.exports = __webpack_public_path__ + "static/media/free-tech1.ab0d9404.jpg";